import { ariaSet } from '@vo/js/utils/aria'

export default (function () {
    const buttons = document.querySelectorAll('.toggle-content-btn')

    if (!buttons.length) return

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            const reviewContent = button.closest('.review-content')
            const shortContent = reviewContent.querySelector('.short-content')
            const fullContent = reviewContent.querySelector('.full-content')

            if (fullContent.classList.contains('hidden')) {
                fullContent.classList.remove('hidden')
                shortContent.classList.add('hidden')
                ariaSet('expanded', button, 'true')
            } else {
                fullContent.classList.add('hidden')
                shortContent.classList.remove('hidden')
                ariaSet('expanded', button, 'false')
            }
        })
    })
})
